module.exports = __webpack_public_path__ + "static/3-651e046f4a7c6f190541001ca173c30a.jpg";